import OakLogo from "@/components/OakLogo";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen" data-testid="terms-page">
      <nav className="max-w-5xl mx-auto px-6 py-5 flex items-center gap-3">
        <Link to="/" className="flex items-center gap-3">
          <OakLogo size={32} />
          <span className="font-display font-semibold">Oak AI Campus</span>
        </Link>
      </nav>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-6 text-white/75 leading-relaxed">
        <div className="label-eyebrow">Legal</div>
        <h1 className="font-display text-4xl tracking-tight text-white">Terms of Service</h1>
        <p className="text-white/55">Effective date: {new Date().toLocaleDateString()}</p>

        <Section title="1. Acceptance of Terms">
          By accessing or using Oak AI Campus (the &ldquo;Service&rdquo;), you agree to be bound by
          these Terms of Service. If you do not agree, do not use the Service. Oak AI Campus is
          owned and operated by <strong>Digiluxcon Technology Services (OPC) Private
          Limited</strong>, a company incorporated in India (&ldquo;we&rdquo;, &ldquo;our&rdquo;,
          &ldquo;us&rdquo;). The platform was conceptualized by Abhishek Singh.
        </Section>

        <Section title="2. Eligibility & Accounts">
          You must be at least 13 years old to use the Service, and at least 18 to make paid
          purchases. You are responsible for maintaining the confidentiality of your Google sign-in
          credentials and for all activity under your account.
        </Section>

        <Section title="3. Credits & Purchases">
          The Service operates on a credit system. Credits are digital goods, non-transferable, and
          carry no monetary value. Purchases of credit packs (Starter, Basic, Master) and the
          Limitless VIP subscription are processed by Razorpay (India) or Lemon Squeezy (Global).
          Prices and pack contents may change at any time. See our Refund Policy for refund rules.
        </Section>

        <Section title="4. Limitless VIP">
          Limitless VIP grants unlimited AI generation for 6 months (180 days) from the date of
          purchase. It is a one-time purchase (not an auto-renewing subscription in V1) and cannot
          be paused, transferred, or stacked with other Limitless periods.
        </Section>

        <Section title="5. Acceptable Use">
          You agree not to (a) reverse-engineer or scrape the Service, (b) use it to generate
          unlawful, defamatory, or infringing content, (c) resell AI outputs as your own original
          work without disclosure, or (d) attempt to bypass credit limits. We may suspend accounts
          that violate these terms.
        </Section>

        <Section title="6. AI-Generated Content">
          Oak AI Campus outputs are generated by third-party language models and may contain inaccuracies.
          Outputs are provided &ldquo;as is&rdquo;. You are responsible for verifying any factual
          claims before relying on them for academic, medical, legal, or financial decisions.
        </Section>

        <Section title="7. Intellectual Property">
          The Service, including its UI, branding, proprietary prompts, and orchestration logic, is
          the exclusive property of Digiluxcon Technology Services (OPC) Private Limited. You retain
          ownership of the goals and inputs you provide. You grant us a worldwide, royalty-free
          licence to process those inputs solely to operate the Service.
        </Section>

        <Section title="8. Privacy & Data">
          See our <Link to="/privacy" className="text-[#8aa8ff] underline">Privacy Policy</Link> for
          how we collect, use, and protect your data. You can delete your account and all
          associated data at any time from <Link to="/settings" className="text-[#8aa8ff] underline">Settings</Link>.
        </Section>

        <Section title="9. Termination">
          You may close your account at any time. We may terminate or suspend access for
          violations of these terms, fraud, chargebacks, or extended inactivity.
        </Section>

        <Section title="10. Limitation of Liability">
          To the fullest extent permitted by law, Digiluxcon Technology Services (OPC) Private
          Limited is not liable for indirect, incidental, or consequential damages arising from
          your use of the Service. Our total liability for any claim is capped at the amount you
          paid us in the prior 12 months.
        </Section>

        <Section title="11. Governing Law">
          These terms are governed by the laws of India. Disputes will be resolved in the courts of
          Bengaluru, India, without prejudice to applicable consumer-protection laws in your
          jurisdiction.
        </Section>

        <Section title="12. Contact">
          Questions? Email <a className="text-[#8aa8ff]" href="mailto:info@oakaiapp.com">info@oakaiapp.com</a>.
        </Section>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="glass p-6">
      <h2 className="font-display text-xl tracking-tight text-white mb-2">{title}</h2>
      <p>{children}</p>
    </section>
  );
}
